import { useState } from "react";

const faqs = [
  {
    question: "Combien de temps dure une pose de carrelage ?",
    answer:
      "La durée dépend de la surface et de la complexité du chantier. Pour une salle de bain standard, comptez 3 à 5 jours. Une cuisine ou un salon peut prendre 1 à 2 semaines. On vous donne un planning précis lors du devis.",
  },
  {
    question: "Faites-vous les devis gratuitement ?",
    answer:
      "Oui, tous nos devis sont gratuits et sans engagement. On se déplace sur place dans le Valais pour évaluer le chantier, mesurer et vous proposer une offre détaillée.",
  },
  {
    question: "Posez-vous du carrelage dans les salles de bain ?",
    answer:
      "Absolument, c'est l'un de nos coeurs de métier. On pose du carrelage mural et au sol dans les salles de bain, avec étanchéité, pente d'écoulement et finitions soignées.",
  },
  {
    question: "Faites-vous la rénovation complète de salle de bain ?",
    answer:
      "Oui, on gère la rénovation complète : démolition, plomberie de surface, pose de carrelage, installation de douche italienne, faïence et mosaïque. Un seul interlocuteur du début à la fin.",
  },
  {
    question: "Quelle est la différence entre un carrelage intérieur et extérieur ?",
    answer:
      "Le carrelage extérieur doit résister au gel, à l'humidité et aux UV. On utilise des carreaux antidérapants et des joints adaptés. En intérieur, on privilégie l'esthétique et le confort.",
  },
  {
    question: "Travaillez-vous avec des particuliers et des professionnels ?",
    answer:
      "On travaille avec les deux. Particuliers pour des rénovations de maisons et appartements, professionnels pour des chantiers de construction, hôtels, restaurants et commerces en Valais.",
  },
  {
    question: "Comment entretenir un carrelage ?",
    answer:
      "Un carrelage bien posé demande peu d'entretien. Un passage à l'eau savonneuse suffit. Évitez les produits acides sur les joints. On vous donne des conseils personnalisés à la fin du chantier.",
  },
  {
    question: "Dans quels délais pouvez-vous intervenir ?",
    answer:
      "Selon la saison et l'urgence, on peut intervenir sous 2 à 4 semaines. Pour les urgences (fuite, carrelage décollé), on essaye de passer dans les 48 heures. Contactez-nous pour connaitre nos disponibilités.",
  },
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map((f) => ({
    "@type": "Question",
    "name": f.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": f.answer,
    },
  })),
};

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-stone-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">
            Questions fréquentes
          </span>
          <h2 className="mt-3 text-4xl font-bold text-stone-900">
            Vous avez des questions ?
          </h2>
          <p className="mt-4 text-stone-500 max-w-xl mx-auto text-sm leading-relaxed">
            Voici les réponses aux questions qu&apos;on nous pose le plus
            souvent. Si vous ne trouvez pas votre réponse, appelez-nous.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="bg-white rounded-lg border border-stone-200 overflow-hidden transition-colors hover:border-amber-300"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm font-semibold text-stone-800">
                    {faq.question}
                  </span>
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-full bg-stone-100 text-stone-500 shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  >
                    <i className="ri-arrow-down-s-line text-base" />
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}
                >
                  <p className="px-6 pb-5 text-sm text-stone-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}